<script lang="ts" setup>
import { TheResponsiveNavbar, TheSnackbar } from '@/components';

const route = useRoute();

const showMobileNavbar = computed((): boolean => {
  return route.path.replace(/\/$/, '') === '/account-setup' || route.path.replace(/\/$/, '') === '/login';
});
</script>

<template>
  <v-layout>
    <v-main class="guest-layout page-background page-background--guest">
      <TheResponsiveNavbar :show-mobile-navbar="!showMobileNavbar" />
      <NuxtPage :page-key="(route) => route.fullPath" />
    </v-main>
    <TheSnackbar />
  </v-layout>
</template>
<style lang="scss" scoped>
.guest-layout {
  padding-top: 0;
}
</style>
